import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';

const Logo = ({ className }) => {
  return (
    <Link to="/" className="block">
      <svg className={className} viewBox="0 0 271 92" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M49.85 92.01L134.69 7.17V92.01H137.66L222.5 7.17V92.01H226.71V0H223.74L138.9 84.84V0H135.92L43.91 92.01H49.85Z" fill="currentColor"/>
        <path d="M232.31 0V4.20001H266.36V92.01H270.56V0H232.31Z" fill="currentColor"/>
        <path d="M178.6 59V92.01H182.8V54.79L178.6 59Z" fill="currentColor"/>
        <path d="M90.79 37.21L94.99 33.01V0H92.02L0 92.01H5.94L90.79 7.17V37.21Z" fill="currentColor"/>
        <path d="M94.99 84.84V54.79L90.79 59V92.01H93.76L129.02 56.75V50.8L94.99 84.84Z" fill="currentColor"/>
        <path d="M179.83 0L144.53 35.29V41.24L178.6 7.17V37.21L182.8 33.01V0H179.83Z" fill="currentColor"/>
      </svg>
    </Link>
  )
};

Logo.propTypes = {
  className: PropTypes.string,
};

Logo.defaultProps = {
  className: 'h-12',
};

export default Logo;
